<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">納入場所グループ詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!form.code || !form.name"
          @click="save"
          v-permit.SHARP_WG_NEW
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="form.id"
                clearable
                label="グループCD"
                v-model.trim="form.code"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="グループ名"
                v-model.trim="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      nameRules: [(v) => !!v || "Name is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/warehouse-groups", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
  computed: {
    canSave() {
      return;
    },
  },
};
</script>
